import { IconCheckDefault } from '@mc/design-system'

const CheckMark = () => (
  <div style={{ width: '32px', height: '32px' }}>
    <IconCheckDefault
      size='scale-8'
      className='mc-border--default mc-bg-primary mc-icon--circled position-absolute mc-m-auto'
    />
  </div>
)

export const CheckMarkItem = ({ children }: { children: string }) => (
  <li className='d-flex mc-mb-4' style={{ gap: 'var(--mc-scale-2)' }}>
    <CheckMark />
    <div className='mc-my-auto'>{children}</div>
  </li>
)
